import { IFilterApplications } from "./types"

import { Button, Container, Divider, Drawer, Empty, Flex, Input, Toogle, ToolTip } from "@ui/index"

import imgEmty from '@img/empty.svg'
import { IconClearClose, IconDateEdit } from "@img/icons"

import css from './ui.module.scss'
import { SelectDate } from "@primitive/calendar"


/** Фильтр - Заявки */
export const ApplicationsFilter = ({ 
    isOpen, filterSites,
    filterApplicationStatuses,
    filterDateNextCallFrom,
    filterDateNextCallBefore,
    filterDateStartEducationFrom,
    filterDateStartEducationBefore,
    filterDateCreateFrom,
    filterDateCreateBefore,
    filterIsBlackListOnly, 
    filterIsBlackListHide,
    filterIsDailyApplications,
    filterIsOvernightApplications,
    handleButtonCancel, handleApplyClearFilter
}: IFilterApplications) => {

    /** Выбор статусов в окне фильтров */
    const handleSelectStatus = (id: number) => {
        const updatedStatuses = filterApplicationStatuses.value.map(status => {
            if (status.id === id) {
                return { ...status, isSelected: !status.isSelected }
            }

            return status // Возвращаем неизмененный элемент для остальных элементов массива
        })

        filterApplicationStatuses.setValue(updatedStatuses)
    }
    /** Убираем все галочки с выбранных статусов в окне фильтров */
    const handleClearSelection = () => {
        const updatedStatuses = filterApplicationStatuses.value.map(status => ({ ...status, isSelected: false }))
        filterApplicationStatuses.setValue(updatedStatuses)
    }

    /** Выбор сайтов в окне фильтров */
    const handleSelectSites = (id: number) => {
        const updatedStatuses = filterSites.value.map(status => {
            if (status.id === id) {
                return { ...status, isSelected: !status.isSelected }
            }

            return status // Возвращаем неизмененный элемент для остальных элементов массива
        })

        filterSites.setValue(updatedStatuses)
    }


    return <>
        <Drawer isOpen={isOpen} zIndex={1001} isEsc isWrapper isWrapperBlur={false} onCancel={handleButtonCancel} maxWidth='370px' placement='right'>
            <Flex className='drawer_container'>
                <Flex flexDirection='row' alignItems='center' justifyContent='space-between' className='drawer_container-header'>
                    <h4>Фильтр...</h4>

                    <Button variant='icon' size='sm' onClick={handleButtonCancel}>
                        <IconClearClose width="20px" height="20px" />
                    </Button>
                </Flex>

                <Flex gap='4px' className='drawer_container-body'>
                    <Flex gap='20px' className='drawer_container-content'>
                        <Flex gap="4px">
                            <Divider prefix='Дата отложенного действия' gap="6px"
                                suffix={(filterDateNextCallFrom.value || filterDateNextCallBefore.value) && 
                                    <ToolTip title='Очистить' placement="left">
                                        <Button size='xs' variant='icon' onClick={() => { 
                                            filterDateNextCallFrom.reset()
                                            filterDateNextCallBefore.reset() 
                                        }}><IconClearClose width='16px' height='16px' /></Button>
                                    </ToolTip>
                                } 
                            />

                            <Flex gap="2px" flexDirection="row">
                                <Input {...filterDateNextCallFrom} 
                                    placeholder='Дата - старт' type='mask' mask='99.99.2099' maskChar="" 
                                    size='md' paddingRight='2px' width='100%' 
                                    maxLength={10}
                                    suffix={
                                        <Flex flexDirection="row">
                                            {filterDateNextCallFrom.value &&
                                                <ToolTip title='Очистить' placement="left">
                                                    <Button size='xs' variant='iconInput' 
                                                        onClick={filterDateNextCallFrom.reset}
                                                    ><IconClearClose width='16px' height='16px' /></Button>
                                                </ToolTip>
                                            }
                                            
                                            <SelectDate currentDate={filterDateNextCallFrom.value} onSelect={(date) => {filterDateNextCallFrom.setValue(date)}}>
                                                <ToolTip title='Выбрать' placement="left">
                                                    <Button size='xs' variant='iconInput'>
                                                        <IconDateEdit width='16px' height='16px' />
                                                    </Button>
                                                </ToolTip>
                                            </SelectDate>
                                        </Flex>
                                    }
                                />

                                <Input {...filterDateNextCallBefore}
                                    placeholder='Дата - конец' type='mask' mask='99.99.2099' maskChar="" 
                                    size='md' paddingRight='2px' width='100%' 
                                    suffix={
                                        <Flex flexDirection="row">
                                            {filterDateNextCallBefore.value && 
                                                <ToolTip title='Очистить' placement="left">
                                                    <Button size='xs' variant='iconInput' 
                                                        onClick={filterDateNextCallBefore.reset}
                                                    ><IconClearClose width='16px' height='16px' /></Button>
                                                </ToolTip>
                                            }
                                            
                                            <SelectDate currentDate={filterDateNextCallBefore.value} onSelect={(date) => {filterDateNextCallBefore.setValue(date)}}>
                                                <ToolTip title='Выбрать' placement="left">
                                                    <Button size='xs' variant='iconInput' >
                                                        <IconDateEdit width='16px' height='16px' />
                                                    </Button>
                                                </ToolTip>
                                            </SelectDate>
                                        </Flex>
                                    }
                                />
                            </Flex>
                        </Flex>

                        <Flex gap="4px">
                            <Divider prefix='Дата начала обучения' gap="6px"
                                suffix={(filterDateStartEducationFrom.value || filterDateStartEducationBefore.value) && 
                                    <ToolTip title='Очистить' placement="left">
                                        <Button size='xs' variant='icon' onClick={() => { 
                                            filterDateStartEducationFrom.reset()
                                            filterDateStartEducationBefore.reset() 
                                        }}><IconClearClose width='16px' height='16px' /></Button>
                                    </ToolTip>
                                } 
                            />

                            <Flex gap="2px" flexDirection="row">
                                <Input {...filterDateStartEducationFrom}
                                    placeholder='Дата - старт' type='mask' mask='99.99.2099' maskChar="" 
                                    size='md' paddingRight='2px' width='100%' 
                                    suffix={
                                        <Flex flexDirection="row">
                                            {filterDateStartEducationFrom.value && 
                                                <ToolTip title='Очистить' placement="left">
                                                    <Button size='xs' variant='iconInput' onClick={
                                                        filterDateStartEducationFrom.reset
                                                    }><IconClearClose width='16px' height='16px' /></Button>
                                                </ToolTip>
                                            }
                                            
                                            <SelectDate currentDate={filterDateStartEducationFrom.value} onSelect={(date) => {filterDateStartEducationFrom.setValue(date)}}>
                                                <ToolTip title='Выбрать' placement="left">
                                                    <Button size='xs' variant='iconInput'>
                                                        <IconDateEdit width='16px' height='16px' />
                                                    </Button>
                                                </ToolTip>
                                            </SelectDate>
                                        </Flex>
                                    }
                                />

                                <Input {...filterDateStartEducationBefore}
                                    placeholder='Дата - конец' type='mask' mask='99.99.2099' maskChar="" 
                                    size='md' paddingRight='2px' width='100%'
                                    suffix={
                                        <Flex flexDirection="row">
                                            {filterDateStartEducationBefore.value && 
                                                <ToolTip title='Очистить' placement="left">
                                                    <Button size='xs' variant='iconInput' onClick={
                                                        filterDateStartEducationBefore.reset
                                                    }><IconClearClose width='16px' height='16px' /></Button>
                                                </ToolTip>
                                            }

                                            <SelectDate currentDate={filterDateStartEducationBefore.value} onSelect={(date) => {filterDateStartEducationBefore.setValue(date)}}>
                                                <ToolTip title='Выбрать' placement="left">
                                                    <Button size='xs' variant='iconInput'>
                                                        <IconDateEdit width='16px' height='16px' />
                                                    </Button>
                                                </ToolTip>
                                            </SelectDate>
                                        </Flex>
                                    }
                                />
                            </Flex>
                        </Flex>

                        <Flex gap="4px">
                            <Divider prefix='Дата создания заявки' gap="6px"
                                suffix={(filterDateCreateFrom.value || filterDateCreateBefore.value) && 
                                    <ToolTip title='Очистить' placement="left">
                                        <Button size='xs' variant='icon' onClick={() => { 
                                            filterDateCreateFrom.reset()
                                            filterDateCreateBefore.reset() 
                                        }}><IconClearClose width='16px' height='16px' /></Button>
                                    </ToolTip>
                                } 
                            />

                            <Flex gap="2px" flexDirection="row">
                                <Input {...filterDateCreateFrom}
                                    placeholder='Дата - старт' type='mask' mask='99.99.2099' maskChar="" 
                                    size='md' paddingRight='2px' width='100%'
                                    suffix={
                                        <Flex flexDirection="row">
                                            {filterDateCreateFrom.value && 
                                                <ToolTip title='Очистить' placement="left">
                                                    <Button size='xs' variant='iconInput' 
                                                        onClick={filterDateCreateFrom.reset}
                                                    ><IconClearClose width='16px' height='16px' /></Button>
                                                </ToolTip>
                                            }
                                            
                                            <SelectDate currentDate={filterDateCreateFrom.value} onSelect={(date) => {filterDateCreateFrom.setValue(date)}}>
                                                <ToolTip title='Выбрать' placement="left">
                                                    <Button size='xs' variant='iconInput'>
                                                        <IconDateEdit width='16px' height='16px' />
                                                    </Button>
                                                </ToolTip>
                                            </SelectDate>
                                        </Flex>
                                    }
                                />

                                <Input {...filterDateCreateBefore}
                                    placeholder='Дата - конец' type='mask' mask='99.99.2099' maskChar="" 
                                    size='md' paddingRight='2px' width='100%' 
                                    suffix={
                                        <Flex flexDirection="row">
                                            {filterDateCreateBefore.value && 
                                                <ToolTip title='Очистить' placement="left">
                                                    <Button size='xs' variant='iconInput' 
                                                        onClick={filterDateCreateBefore.reset}
                                                    ><IconClearClose width='16px' height='16px' /></Button>
                                                </ToolTip>
                                            }
                                            
                                            <SelectDate currentDate={filterDateCreateBefore.value} onSelect={(date) => {filterDateCreateBefore.setValue(date)}}>
                                                <ToolTip title='Выбрать' placement="left">
                                                    <Button size='xs' variant='iconInput'>
                                                        <IconDateEdit width='16px' height='16px' />
                                                    </Button>
                                                </ToolTip>
                                            </SelectDate>
                                        </Flex>
                                    }
                                />
                            </Flex>
                        </Flex>

                        <Flex gap="4px">
                            <Divider prefix='Чёрный лист' gap="6px"
                                suffix={(filterIsBlackListOnly.value || filterIsBlackListHide.value) && 
                                    <ToolTip title='Очистить' placement="left">
                                        <Button size='xs' variant='icon' onClick={() => { 
                                            filterIsBlackListOnly.reset()
                                            filterIsBlackListHide.reset() 
                                        }}><IconClearClose width='16px' height='16px' /></Button>
                                    </ToolTip>
                                } 
                            />

                            <Flex gap="4px">
                                <Container padding="4px 3px 4px 10px" className={css['filter_toogle_container']}>
                                    <p>Скрыть чёрный лист:</p>

                                    <Toogle checked={filterIsBlackListHide.value === '1' ? true : false} 
                                        onChange={(e) => {
                                            filterIsBlackListOnly.setValue('')
                                            filterIsBlackListHide.setValue(e.target.checked ? '1' : '0')
                                        }} 
                                    />
                                </Container>

                                <Container padding="4px 3px 4px 10px" className={css['filter_toogle_container']}>
                                    <p>Показать только чёрный лист:</p>

                                    <Toogle checked={filterIsBlackListOnly.value === '1' ? true : false}
                                        onChange={(e) => {
                                            filterIsBlackListHide.setValue('')
                                            filterIsBlackListOnly.setValue(e.target.checked ? '1' : '0')
                                        }} 
                                    />
                                </Container>
                            </Flex>
                        </Flex>

                        <Flex gap="4px">
                            <Divider prefix='Отобразить заявки' gap="6px" />

                            <Flex gap="4px">
                                <Container padding="4px 3px 4px 10px" className={css['filter_toogle_container']}>
                                    <p>Дневные:</p>

                                    <Toogle checked={filterIsDailyApplications.value === '1' ? true : false} 
                                        onChange={(e) => {
                                            filterIsDailyApplications.setValue(e.target.checked ? '1' : '0')
                                        }} 
                                    />
                                </Container>

                                <Container padding="4px 3px 4px 10px" className={css['filter_toogle_container']}>
                                    <p>Ночные:</p>

                                    <Toogle checked={filterIsOvernightApplications.value === '1' ? true : false}
                                        onChange={(e) => {
                                            filterIsOvernightApplications.setValue(e.target.checked ? '1' : '0')
                                        }} 
                                    />
                                </Container>
                            </Flex>
                        </Flex>

                        <Flex gap="4px">
                            <Divider prefix='Отобразить заявки сайта' gap="6px" />

                            <Flex gap="4px">
                                {filterSites && filterSites.value.map(item => {
                                    return (
                                        <Container key={item.id} padding="4px 3px 4px 10px" className={css['filter_toogle_container']}>
                                            <p>{item.description}:</p>
                                            <Toogle checked={item.isSelected} onChange={() => handleSelectSites(item.id)} />
                                        </Container>
                                    )
                                })}
                            </Flex>
                        </Flex>

                        <Flex gap="4px">
                            <Divider prefix='Показать только выбранные статусы' gap="6px" suffix={
                                filterApplicationStatuses.value.filter((item) => item.isSelected === true).length > 0 && 
                                    <ToolTip title='Очистить' placement="left">
                                        <Button size='xs' variant='icon' onClick={handleClearSelection}>
                                            <IconClearClose width='16px' height='16px' />
                                        </Button>
                                    </ToolTip>
                                } 
                            />

                            <Flex gap="4px">
                                {filterApplicationStatuses.value.length === 0
                                    ? <Empty image={imgEmty} title="Данные отсутствуют" size='100px' /> 
                                    : filterApplicationStatuses.value.map((item) => {
                                        return (
                                            <Container key={item.id} padding="4px 3px 4px 10px" className={css['filter_toogle_container']}>
                                                <p>{item.name}:</p>
                                                <Toogle checked={item.isSelected} onChange={() => handleSelectStatus(item.id)} />
                                            </Container>
                                        )
                                    })
                                }
                            </Flex>
                        </Flex>
                    </Flex>

                    <div style={{gap: '5px', display: 'grid', gridTemplateColumns: '1fr 1fr'}}>
                        <Button variant="primaryDark" onClick={() => handleApplyClearFilter('clear')}>Очистить</Button>
                        <Button onClick={() => handleApplyClearFilter('apply')}>Применить</Button>
                    </div>
                </Flex>
            </Flex>
        </Drawer>
    </>
}